import { tokenStorage } from '../utils/tokenStorage';

/**
 * Access-token only (no refresh flow). Returns the stored bearer token if still valid.
 */
export const tokenRefreshService = {
  getValidAccessToken: async () => {
    const accessToken = tokenStorage.getAccessToken();
    if (!accessToken) {
      return null;
    }
    if (tokenStorage.isTokenExpired()) {
      tokenStorage.clearTokens();
      return null;
    }
    return accessToken;
  },
};
